import {Icon, IconButton, makeStyles, Typography} from "@material-ui/core";
import {DragDropContext, Droppable} from "react-beautiful-dnd";
import QuestionItem from "./QuestionItem";
import QuestionModal from "./QuestionModal";
import React, {useState} from "react";
import JsonScreenHoc from "../../../../../../../HocHelpers/JsonScreenHoc";

const initialQuestionModalState = {
    open: false,
    record: null,
    index: null,
}
const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: '100%',
        width: '100%',
        position: 'relative',
    }
}))
const Questions = ({questions, values, removeGroup, dataSource, setValue}) => {
    const [questionModalState, setQuestionModalState] = useState(initialQuestionModalState)
    const classes = useStyles();

    function onDragEnd(result) {
        const reorder = (list, startIndex, endIndex) => {
            const result = Array.from(list);
            const [removed] = result.splice(startIndex, 1);
            result.splice(endIndex, 0, removed);
            return result;
        };
        const reordered = reorder(values.questions, result.source.index, result.destination.index);
        setValue(reordered, `${dataSource}.questions`)
    }

    function saveQuestion(value) {
        setValue(value, `${dataSource}.questions.${questionModalState.index}`)
    }

    return (
        <>
            <div>
                <Typography variant={"subtitle2"} style={{paddingTop: 5}}>Questions</Typography>
                <div className={classes.container}>
                    <div style={{
                        width: '100%',
                        display: "flex",
                        background: 'rgba(0,0,0,0.04)',
                        padding: 10,
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                        marginTop: 10
                    }}>
                        <div style={{width: '35%'}}>
                            <Typography variant={"subtitle2"} style={{fontWeight: 600}}>Question Type</Typography>
                        </div>
                        <div style={{width: '35%'}}>
                            <Typography variant={"subtitle2"} style={{fontWeight: 600}}>Label</Typography>
                        </div>
                        <div style={{width: '35%'}}>
                            <Typography variant={"subtitle2"} style={{fontWeight: 600}}>Points</Typography>
                        </div>
                        <div style={{
                            padding: "10px 22px",
                            visibility: 'hidden'
                        }}>
                            a
                        </div>
                    </div>
                    <div style={{width: '100%'}}>
                        <DragDropContext onDragEnd={onDragEnd}>
                            <Droppable droppableId="questions">
                                {(provided) => (
                                    <div
                                        {...provided.droppableProps}
                                        ref={provided.innerRef}
                                    >
                                        {questions?.map((question, index) => (
                                            <QuestionItem
                                                question={question}
                                                index={index}
                                                key={index}
                                                setQuestionModalState={setQuestionModalState}
                                                dataSource={dataSource}
                                                removeGroup={removeGroup}
                                            />
                                        ))}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </div>
                    <div style={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                        alignItems: "center"
                    }}>
                        {!questions || !questions?.length && (
                            <Typography
                                variant={"subtitle2"}
                                color={"textSecondary"}
                                style={{padding: "15px 0 5px 0"}}
                            >
                                No questions found
                            </Typography>
                        )}
                        <IconButton
                            size={"small"}
                            style={{marginTop: 5}}
                            onClick={() => {
                                setQuestionModalState({
                                    open: true,
                                    index: questions?.length || 0,
                                })
                            }}>
                            <Icon fontSize="small">
                                add
                            </Icon>
                        </IconButton>
                    </div>
                </div>
            </div>
            <QuestionModal
                open={questionModalState.open}
                record={questionModalState.record}
                path={questionModalState.path}
                surveyType={values.type}
                saveQuestion={saveQuestion}
                onClose={() => setQuestionModalState(initialQuestionModalState)}
            />
        </>
    )
}
export default JsonScreenHoc(Questions)